import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import { useFonts } from '@/composables/fonts';
import FontSelector from '../FontSelector.vue';
import CInput from '@/components/shared/CInput.vue';
import type { CSelectItem } from '@/components/shared/CSelect';
import type { ImagePlaceholderElement, WordSearchConfig } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';
import { ptToPx, pxToPt } from '@/utils/elementsUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CharacterProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    imageElement?: ImagePlaceholderElement;
    editMode?: boolean;
};



const model = reactive({
    font: undefined as CSelectItem<string> | undefined,
    fontSize: 20
});

const canvasDpi = computed(() => props.canvas.DPI);

const { getFontFromPath, generateFontName } = useFonts();
watch(
    () => props.imageElement,
    (element) => {
        if (!element || !element.wordSearchConfig) return;

        const config = element.wordSearchConfig;
        model.fontSize = pxToPt(config.fontSize || 0, canvasDpi.value);

        const font = getFontFromPath(config.font);
        if (font) {
            model.font = {
                label: generateFontName(font),
                value: config.font
            };
        }
    },
    { immediate: true }
);

const disabled = computed(() => !!props.imageElement?.locked);

const onFontSelected = () => {
    if (!model.font?.value) return;
    updateWordSearchConfig({ font: model.font.value });
};

const updateFontSize = (value = 0) => {
    updateWordSearchConfig({ fontSize: ptToPx(value, canvasDpi.value) });
};

const updateWordSearchConfig = (config: Partial<WordSearchConfig>) => {
    const element = props.imageElement;
    if (!element) return;

    const newConfig = { ...element.wordSearchConfig, ...config } as WordSearchConfig;
    element.set('wordSearchConfig', newConfig);
    if (props.editMode) element.setEditedProp('wordSearchConfig');
};

return { __sfc: true,props, model, canvasDpi, getFontFromPath, generateFontName, disabled, onFontSelected, updateFontSize, updateWordSearchConfig, FontSelector, CInput }
}

})